<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Misión Actual</h4>
              <p class="pull">{{this.misionActual}}</p>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md6 lg6 xs6 sm6 xl6>
              <h4 class="pull" style="rgb(235, 119, 4)">Misión Propuesta</h4>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      style="text-align: left"
                      :class="header.size"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <!-- v-for="(item,index) in items" :key="index" -->
                    <td style="text-align:left " :class="headers[0].size">{{items[0].title}}</td>
                    <td
                      style="text-align:left "
                      :class="headers[1].size"
                    >{{estadistica.totalValido}}</td>
                    <td style="text-align:left " :class="headers[2].size">{{estadistica.pctValido}}</td>
                    <td style="text-align:left " :class="headers[0].size">{{items[1].title}}</td>
                    <td
                      style="text-align:left "
                      :class="headers[1].size"
                    >{{estadistica.totalAlcance}}</td>
                    <td style="text-align:left " :class="headers[2].size">{{estadistica.pctAlcance}}</td>
                    <td style="text-align:left " :class="headers[0].size">{{items[2].title}}</td>
                    <td
                      style="text-align:left "
                      :class="headers[1].size"
                    >{{estadistica.totalSugiero}}</td>
                    <td style="text-align:left " :class="headers[2].size">{{estadistica.pctSugiero}}</td>
                    <!-- <td :class="headers[3].size">
                      <v-icon small class="mr-2" @click="openEditObservaciones(item,index)">edit</v-icon>
                    </td>-->
                  </tr>
                </tbody>
              </table>
            </v-flex>
            <v-flex md6 lg6 xs6 sm6>
              <v-card class="pull v-card-new">
                <h4 class="titlep">Propuesta Misión</h4>
                <p class="text-mision">{{this.misionPropuesta}}</p>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- <v-layout>
      <v-dialog v-model="asistencia" width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Asistencia DGE</span>
          </v-card-title>
          <div class="form-group">
            <label for="comment">Comenta tus inquietudes</label>
            <textarea class="form-control" rows="9" id="comment" v-model="visionPropuesta"></textarea>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="asistencia = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout> -->

    <v-layout>
      <v-dialog v-model="dialog" width="500px">
        <template v-slot:activator="{ on }">
          <!-- <v-btn color="#394049" @click="opencreateObservaciones">Agregar Observación</v-btn> -->
          <v-btn v-if="$session.getAll().permiso" color="#EB7704" v-on="on">Editar misión propuesta</v-btn>
          <!-- <v-btn color="#EB7704">Finalizar</v-btn> -->
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Edita la Misión</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="comment">Propuesta de misión:</label>
                <textarea class="form-control" rows="5" id="comment" v-model="misionPropuesta"></textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="dialog = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="updateMision(misionPropuesta)">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="500px">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Edita Observaciones</span>
            <span class="headline" v-if="create">Crear Observacion</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Colaborador</label>
                <select class="form-control" id="sel1" v-model="observacion.title">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Director/a">Director/a</option>
                  <option value="Sub Director/a">Sub Director/a</option>
                  <option value="Jefe de carrera">Jefe/a de Carrera</option>
                  <option value="Estudiante">Estudiante</option>
                  <option value="Académico/a">Académico/a</option>
                  <option value="Funcionario/a">Funcionario/a</option>
                  <option value="Egresado/a">Egresado/a</option>
                  <option value="Empleador/a">Empleador/a</option>
                </select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Opinión</label>
                <select class="form-control" id="sel1" v-model="observacion.icon">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Valido la misión">Valido la misión</option>
                  <option
                    value="Valido la misión con alcances menores"
                  >Valido la misión con alcances menores</option>
                  <option value="Sugiero una nueva misión">Sugiero una nueva misión</option>
                </select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Alcances/Propuestas</label>
                <input v-model="observacion.path" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editObservacion()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createObservacion()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/BANNER_2.png";
import img3 from "../../assets/nuevaasistencia.png";

export default {
  data() {
    return {
      mision: "",
      misionActual: "",
      misionPropuesta: "",
      idMision: "",
      img3: img3,
      asistencia: false,
      create: false,
      edit: false,
      index: "",
      dialog: false,
      observacion: {
        title: "",
        icon: "",
        path: ""
      },
      estadistica: "",
      headers: [
        {
          text: "Validación",
          value: "name",
          size: "col-md-6 col-lg-6 col-sm-6 col-xs-6 col-xl-6"
        },

        {
          text: "N° respuestas",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3 col-xl-3"
        },
        {
          text: "Porcentaje",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3 col-xl-3"
        } /* ,
        {
          text: "Editar",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        } */
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,
      items: [
        {
          title: "Valido la misión",
          pct: "",
          total: ""
        },
        {
          title: "Valido la misión, pero con alcances",
          pct: "",
          total: ""
        },
        {
          title: "Sugiero una nueva misión",
          pct: "",
          total: ""
        }
      ],
      right: null,
      timeout: 6000,
      alertType: "success",
      alertMessage: "",
      alert: false
    };
  },
  created() {
    this.getMision();
  },
  methods: {
    getStatistics() {
      var id = this.$session.getAll().ccData.ccValor;
      axios
        .get(
          process.env.ROOT_API +
            "/observacionMision/countOpiniones?ccValor=" +
            id,
          this.auth
        )
        .then(response => {
          this.estadistica = response.data;
          //console.log(response.data);
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    },
    getMision() {
      var id = this.$session.getAll().ccData.ccValor;
      axios
        .get(
          process.env.ROOT_API + "/mision/getAllByCC?ccValor=" + id,
          this.auth
        )
        .then(response => {
          this.misionActual = response.data[0].actual;
          this.misionPropuesta = response.data[0].propuesta;
          this.idMision = response.data[0].id;
          this.mision = response.data[0];
          //console.log(response.data);
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        })
        .then(response => {
          this.getStatistics();
        });
    },
    redirect(index) {
      this.typeEstrategico = index;
    },

    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    updateMision() {
      this.mision.propuesta = this.misionPropuesta;
      axios
        .put(
          process.env.ROOT_API + "/mision/updateMision",
          this.mision,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert("success", "Misión propuesta editada");
          this.getMision();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        })
        .then(response => {
          this.getMision();
        });
      this.dialog = false;
    },

    openEditObservaciones(observacion, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.observacion = observacion;
    },

    opencreateObservaciones() {
      this.create = true;
      this.edit = true;
      this.observacion = {
        title: "",
        icon: "",
        path: ""
      };
    },

    editObservacion() {
      this.items[this.index] = this.observacion;
      this.edit = false;
    },

    createObservacion() {
      this.items.push(this.observacion);
      this.edit = false;
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    }
  }
};
</script>


<style scoped>
.new-alert {
  z-index: 9000;
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.new-alert .theme--light.v-icon {
  color: #ffffff !important;
}
.text-mision {
  color: rgb(255, 255, 255);
}

.titlep {
  color: #ec6a12;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 250px !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.image {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/definicionEstrategica/Mision.vue